import { useController } from 'react-hook-form';
import { SelectPicker, InputGroup, HStack, Loader } from 'rsuite';
import { FormGroup } from '@shared/ui/forms/display';
import { icons } from '@shared/static/icons';
import { useTranslation } from 'react-i18next';

export default function BasicSelectInput({
  control,
  name,
  isRequired = false,
  label,
  error,
  placeholder = '',
  icon,
  className,
  data,
  valueKey = 'id',
  labelKey = 'name',
  groupBy,
  Render,
  searchable = false,
  cleanable = true,
  disabled = false,
  loading = false,
  onChange,
  onOpen,
  onButtonClick,
}) {
  const { t } = useTranslation();
  const { field } = useController({
    control,
    name,
    rules: { required: isRequired },
  });

  function renderItem(label, item) {
    if (Render) return <Render item={item} label={label} />;
    return item?.name || t(item?.label, { defaultValue: item?.label });
  }

  return (
    <FormGroup label={label} error={error}>
      <InputGroup
        inside
        className={field.value != null ? 'has-value' : ''}
        disabled={disabled}
      >
        <SelectPicker
          {...field}
          className={className}
          label={icons[icon]}
          searchable={searchable}
          data={data}
          valueKey={valueKey}
          labelKey={labelKey}
          placeholder={placeholder}
          cleanable={cleanable}
          caret={!disabled}
          groupBy={groupBy}
          block
          renderOption={renderItem}
          renderValue={renderItem}
          onChange={(value) => {
            field.onChange(value);
            onChange?.(value);
          }}
          onOpen={onOpen}
          {...(loading && {
            renderListbox: () => (
              <HStack justifyContent="center">
                <Loader />
              </HStack>
            ),
          })}
        />
        {onButtonClick && (
          <InputGroup.Button onClick={onButtonClick}>
            {icons.add}
          </InputGroup.Button>
        )}
      </InputGroup>
    </FormGroup>
  );
}
